import React from 'react'
import moment from 'moment'

import {
  CONTRACT_TYPE_TO_NAME_MAP,
  CONTRACT_TYPES,
  CONTRACT_TYPES_ENUM,
} from '../../../../../shared/constants'
import { showReduxModal } from '../../../../../Reducers/UI/actions'

export const handlingErrorContractAvailabilitiesPopup = ({
  userId,
  availabilities,
  mission,
  brandAmbassadors,
  dispatch,
  setContractWarning = () => {},
  setIsContractWarningSkipped = () => {},
}) => {
  const content = getModalContent({
    userId,
    availabilities,
    mission,
    brandAmbassadors,
  })

  if (content) {
    const { title, text } = content
    setContractWarning(text)
    setIsContractWarningSkipped(false)
    setTimeout(() => {
      dispatch(
        showReduxModal({
          title,
          children: <div style={{ textAlign: 'center' }}>{text}</div>,
          confirmLabel: 'Confirm',
          hideCancel: true,
        }),
      )
    }, 300)
  } else {
    setContractWarning('')
    setIsContractWarningSkipped(false)
  }
}

export const getModalContent = ({
  userId,
  availabilities,
  mission,
  brandAmbassadors,
}) => {
  const userAvailabilities = availabilities[userId]
  if (userAvailabilities) {
    const {
      name,
      documentType,
      accessibilityWithMissions: {
        availableMissions,
        availableExtraMissions,
        accessibility,
      },
    } = userAvailabilities

    const contractName = CONTRACT_TYPE_TO_NAME_MAP[documentType]
    const momentDate = moment(mission.dateTime)

    const dayNumber = momentDate.isoWeekday()
    const dayOfWeek = momentDate.format('dddd').toUpperCase()

    const sundayWarning =
      dayNumber === 7
        ? 'It is not possible to schedule missions for Sundays. Please try again on an eligible day.'
        : ''
    const isSaturday = dayNumber === 6

    if (sundayWarning) {
      return { text: sundayWarning, title: `Warning (${contractName})` }

      //We have the same time off on accessibility on full day
    } else if (accessibility[dayOfWeek]['LUNCH'].isTimeOff) {
      const text = `BA ${name} cannot be allocated to this mission. Reason: approved time-off period in effect.`

      return { text, title: `Warning (${contractName})` }
    } else if (accessibility[dayOfWeek]['LUNCH'].isExpiredContract) {
      const text = `BA ${name} cannot be allocated to this mission. Reason: This BA does not have a contract for this time period.`

      return { text, title: `Warning (${contractName})` }
    }

    if (
      CONTRACT_TYPES_ENUM[CONTRACT_TYPES.GERMANY_WORKING_STUDENT] !==
      documentType
    ) {
      return null
    } else {
      if (!availableMissions && availableExtraMissions) {
        if (!isSaturday) {
          const text = `BA ${name} have ${availableExtraMissions} available extra mission. BUT FOR THIS TYPE OF CONTRACT WE CAN ASSIGN EXTRA MISSION ONLY ON SATURDAY`

          return { text, title: `Warning (${contractName})` }
        } else {
          const text = `BA ${name} have ${availableExtraMissions} available extra mission. This mission will be used as extra. ${sundayWarning}`

          return { text, title: `Warning (${contractName})` }
        }
      } else if (!availableMissions && !availableExtraMissions) {
        const text = `BA ${name} have ${availableMissions} available mission and ${availableExtraMissions} available extra mission. ${sundayWarning}`

        return { text, title: `Warning (${contractName})` }
      } else if (availableMissions) {
        return null
      }
    }
  } else {
    const ba = brandAmbassadors.find(ba => ba.id === userId)

    const text = `Cannot get contract for ${
      ba ? ba.name : 'BA'
    }. We not recommend assign this BA for this mission. List BAs with contract in table below`

    return { text, title: `Warning ${ba ? ` (${ba.name})` : ''}` }
  }
}

export const replaceGermanCharacters = str => {
  return str
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/ü/g, 'u')
    .replace(/ß/g, 's')
}

export const getTimeOfDayAndDayStringFromMissionDate = ({
  missionDate,
  cityCheckInTimes,
}) => {
  const missionDateNumber = Number(
    missionDate
      .split('T')[1]
      .replace(':', '')
      .slice(0, 4),
  )
  const morningTimeNumber = Number(
    cityCheckInTimes.morningCheckInTime.replace(':', '').slice(0, 4),
  )
  const lunchTimeNumber = Number(
    cityCheckInTimes.lunchCheckInTime.replace(':', '').slice(0, 4),
  )
  const afternoonTimeNumber = Number(
    cityCheckInTimes.afternoonCheckInTime.replace(':', '').slice(0, 4),
  )

  const day = moment(missionDate).format('dddd')

  if (missionDateNumber >= afternoonTimeNumber) {
    return { timeOfDay: 'AFTERNOON', day: day.toUpperCase() }
  }
  if (missionDateNumber >= lunchTimeNumber) {
    return { timeOfDay: 'LUNCH', day: day.toUpperCase() }
  }
  if (missionDateNumber >= morningTimeNumber) {
    return { timeOfDay: 'MORNING', day: day.toUpperCase() }
  }

  return { timeOfDay: 'MORNING', day: day.toUpperCase() }
}
